import { render, staticRenderFns } from "./RemoteConsultationTableCmp1.vue?vue&type=template&id=2f1116fa&"
import script from "./RemoteConsultationTableCmp1.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationTableCmp1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports